import React, { CSSProperties, FormEvent, useState } from "react";
import { api } from "shared/api";
import { useApiMethod } from "shared/lib";
import { Button, Fieldset, Select } from "shared/ui";

export interface ICompanyFinancialDayForm {
  companySlug: string;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const CompanyFinancialDayForm = (props: ICompanyFinancialDayForm) => {
  const financeSettings = api.financeSettings.useFinanceSettingsGet(props.companySlug);
  const submit = useApiMethod(api.financeSettings.financeSettingsUpdate);

  const [value, setValue] = useState<number>();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!financeSettings.data || !value) return;
    await submit.call(props.companySlug, { financialPlanningWeekDay: value });
    await financeSettings.mutate();
    setValue(undefined);
  };

  return (
    <form className={props.className} style={props.style} id={props.htmlId} onSubmit={onSubmit}>
      <Fieldset>
        <Fieldset.Content>
          <Fieldset.Title>День финансового планирования</Fieldset.Title>
          <Fieldset.Subtitle>
            Установите день, в который каждую неделю будет проводиться финансовое планирование. Этот день нельзя
            пропускать.
          </Fieldset.Subtitle>
          <Select
            style={{ maxWidth: 200 }}
            value={value ?? financeSettings.data?.financialPlanningWeekDay}
            onChange={setValue}
            options={[
              { value: 1, label: "Понедельник" },
              { value: 2, label: "Вторник" },
              { value: 3, label: "Среда" },
              { value: 4, label: "Четверг" },
              { value: 5, label: "Пятница" },
              { value: 6, label: "Суббота" },
              { value: 7, label: "Воскресенье" },
            ]}
          ></Select>
        </Fieldset.Content>
        <Fieldset.Footer>
          <Fieldset.Footer.Status>
            {!submit.error && <>Рекомендуется Четверг, но вы можете установить любой день</>}
            {submit.error && <Fieldset.Error>{submit.error.message}</Fieldset.Error>}
          </Fieldset.Footer.Status>
          <Fieldset.Footer.Actions>
            <Button size="small" disabled={!value} loading={submit.loading}>
              Сохранить
            </Button>
          </Fieldset.Footer.Actions>
        </Fieldset.Footer>
      </Fieldset>
    </form>
  );
};

CompanyFinancialDayForm.defaultProps = {};
